export const actionTypes = {
    SET_FORM_TYPE: 'SET_FORM_TYPE',
    SET_FORM_DATA: 'SET_FORM_DATA',
    NEXT_STEP: 'NEXT_STEP',
    PREVIOUS_STEP: 'PREVIOUS_STEP',
    RESET_FORM: 'RESET_FORM',
    SET_CURRENT_STEP: 'SET_CURRENT_STEP',

    SET_SESSION_ID:'SET_SESSION_ID',
    SET_APPLICATION_ID: 'SET_APPLICATION_ID',
    SET_CRM_LEAD_ID: 'SET_CRM_LEAD_ID'
};

export const setSessionId=(sessionId)=>({
    type:actionTypes.SET_SESSION_ID,
    payload:sessionId
})

export const setApplicationId=(applicationId)=>({
    type:actionTypes.SET_APPLICATION_ID,
    payload:applicationId
})

export const setCrmLeadId=(crmLeadId)=>({
    type:actionTypes.SET_CRM_LEAD_ID,
    payload:crmLeadId
})

export function setFormType(formType) {
    return {
        type: actionTypes.SET_FORM_TYPE,
        payload: formType,
    };
}

export const setFormData = (key, value) => ({
    type: actionTypes.SET_FORM_DATA,
    payload: { key, value }
});

export const nextStep = () => ({
    type: actionTypes.NEXT_STEP
});

export const previousStep = () => ({
    type: actionTypes.PREVIOUS_STEP
});

export const resetForm = () => ({
    type: actionTypes.RESET_FORM,
  });


export const setCurrentStep = (step) => ({
  type: actionTypes.SET_CURRENT_STEP,
  payload: step,
});

